import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '../accreditation/assets/css/DocumentDocTypeModal.css';
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import LoadingScreen from "../util/LoadingScreen";
import HospitalSearch from "../hospital/HospitalSearch";
import Select from "react-select";
import AuthService from "../login/AuthService";

const ImportModal = ({ show, onHide, importType }) => {
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [typeDoc, setTypeDoc] = useState({ formFile: '', department_id : null });
    const [loading, setLoading] = useState(false);
    const [modalData, setModalData] = useState(null); // Estado para dados dinâmicos do modal
    const [notFound, setNotFound] = useState(false); // Estado para recurso não encontrado
    const fileInputRef = useRef(null);
    const [visibleHospital, setVisibleHospital] = useState(false);
    const [visibleDepartment, setVisibleDepartment] = useState(false);
    const [fileAccept, setFileAccept] = useState("");
    const userData = AuthService.getUserData();
    // Busca os dados do modal da API
    const fetchModalData = async () => {
        setLoading(true);
        try {
            const response = await ApiService.send(
                'get',
                `${process.env.REACT_APP_URL_API}import/type`, {id: importType}, true
            );

            const {data} =   ApiService.handleApiResponse(response);


            if (data) {
                const { name, template,  visible_hospital, visible_department, accept, id } = data;
                setModalData({ name, template, id });
                setVisibleHospital(visible_hospital);
                setVisibleDepartment(visible_department);
                setFileAccept(accept);
                setNotFound(false); // Recurso encontrado
            } else {
                setNotFound(true); // Recurso não encontrado
            }


        } catch (error) {
            ApiService.handleApiError(error);
            setNotFound(true); // Considera como não encontrado em caso de erro
        } finally {
            setLoading(false);
        }
    };



    const fetchDepartment = async () => {
        try {
            const response = await ApiService.send('post', `${process.env.REACT_APP_URL_API}departments/list-department`, { all: true, status: 'S'}, true);
            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            const options = data.map(department => ({
                value: department.id,
                label: department.name,
            }));

            setDepartmentOptions(options);

        } catch (error) {
            ApiService.handleApiError(error);
        }
    };

    useEffect(() => {
        if (show) {
            // Limpa o campo de arquivo ao abrir o modal
            setTypeDoc({ formFile: '' });
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            // Busca os dados do modal ao ser exibido
            fetchModalData();
            fetchDepartment();
        }
    }, [show]);

    const handleChange = (e) => {
        setTypeDoc({
            ...typeDoc,
            [e.target.id]: e.target.files[0]
        });
    };

    const handleSave = (e) => {
        e.preventDefault();
        setLoading(true);

        const formData = new FormData();
        formData.append('file', typeDoc.formFile);
        formData.append('import_types_id', importType);

        if (typeDoc.hospital) {
            formData.append('hospital_id', typeDoc.hospital);
        }


        if (typeDoc.department_id){
            formData.append('department_id', typeDoc.department_id);
        }


        ApiService.sendArquivo('post', `${process.env.REACT_APP_URL_API}import/send`, formData, true)
            .then((res) => {
                if (res.code === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Sucesso!',
                        text: 'Arquivo salvo com sucesso. Em até 1 hora será processado!',
                    });
                    onHide();
                }
            })
            .catch((error) => {
                console.error('Erro ao salvar o arquivo:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: error.response?.data?.message || 'Ocorreu um erro ao salvar o documento.',
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };


    const onHospitalSelect = (hospital) => {
        if (hospital && hospital.value) {
            setTypeDoc((prevFilters) => ({...prevFilters, hospital: hospital.value}));
        } else {
            setTypeDoc((prevFilters) => ({...prevFilters, hospital: ""}));
        }
    };


    const handleSelectChangeDepartment = (selectedOption) => {
        setTypeDoc(prevData => ({
            ...prevData,
            department_id: selectedOption ? selectedOption.value : ''
        }));
    };

    const downloadTemplate = async (templateId) => {
        try {
            // Enviar a solicitação com o tipo de resposta configurado como blob
            const response = await ApiService.send("get", `${process.env.REACT_APP_URL_API}import/download-template`, {id:templateId}, true,  'blob');

            const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const downloadUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = `template_${new Date().toISOString().split('T')[0]}.xlsx`;
            link.click();
            URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };


    return (
        <>
            {show && <div className="modal-backdrop fade show"></div>}
            <div className={`modal fade ${show ? 'show d-block' : ''}`} tabIndex="-1" aria-labelledby="documentDocTypeModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="documentDocTypeModalLabel">
                                Importação - {notFound ? 'Recurso não encontrado' : modalData?.name} {/* Exibe título ou mensagem de erro */}
                            </h5>
                            <button type="button" className="btn-close"  onClick={() =>onHide()} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {loading && <LoadingScreen />} {/* Exibe carregamento */}
                            {!loading && notFound && (
                                <div className="text-center">
                                    <p className="text-danger">O recurso solicitado não foi localizado. Por favor, tente novamente.</p>
                                </div>
                            )}
                            {!loading && !notFound && modalData && (
                                <form onSubmit={handleSave}>
                                    {/* Exibição do template */}

                                    {modalData && (
                                        <button
                                            type="button"
                                            className="btn btn-primary mt-2 text-white"
                                            onClick={(event) => {
                                                event.preventDefault();  // Impede que um formulário pai seja enviado
                                                event.stopPropagation(); // Impede que o evento se propague para elementos pais
                                                downloadTemplate(modalData.id); // Executa a função de download
                                            }}
                                        >
                                            <i className="fa fa-download me-2"></i> Download Modelo
                                        </button>

                                    )}


                                    {visibleHospital == 1 && (
                                        <div className="mb-3">
                                            <HospitalSearch buttonAdd={false}
                                                onHospitalSelect={onHospitalSelect}
                                                validateManager={true}
                                                cache={false}
                                            />
                                        </div>
                                    )}

                                    {visibleDepartment == 1 && (
                                        <div className="col-12 form-group mt-2">
                                            <label>Departamento</label>
                                            <Select
                                                isClearable={true}
                                                value={departmentOptions.find(option => option.value === typeDoc.department_id) || null}
                                                onChange={handleSelectChangeDepartment}
                                                options={departmentOptions}
                                                placeholder="Selecione o departamento"
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                                styles={{
                                                    menuPortal: base => ({
                                                        ...base,
                                                        zIndex: 9999
                                                    }), // Definindo z-index alto
                                                    menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                                }}
                                            />
                                        </div>
                                    )}




                                    <div className="mb-3">
                                        <label htmlFor="formFile" className="form-label">Arquivo</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            id="formFile"
                                            ref={fileInputRef}
                                            onChange={handleChange}
                                            accept={fileAccept}
                                            required
                                        />
                                    </div>

                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={() =>onHide()}>
                                            <i className="fa fa-close"></i> Cancelar</button>
                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                            <i className="fa fa-upload"></i> Importar
                                        </button>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ImportModal;
